import { render, staticRenderFns } from "./RecepcionContenedorRecibirComponent.vue?vue&type=template&id=2ac4c234&"
import script from "./RecepcionContenedorRecibirComponent.vue?vue&type=script&lang=js&"
export * from "./RecepcionContenedorRecibirComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports